import React, { useEffect, useRef, useState } from "react";
import { Card, Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { Icons } from "../Icons";
import Buttons from "../Buttons";
import { addCommas } from "../../helpers/helpers";
import { FUNDNAME } from "../../constants/constants";
import "./savingsbarchart.scss";

const SavingsBarChart = (props) => {
  const {
    viewPotInfo,
    percentages,
    savingsPotBreakdown,
    savingsPercentages,
    savingsBreakdown,
    mobileView,
    selectedIndex,
    drawDownBreakdown,
    drawDownPotBreakdown,
    drawDownPercentages,
    fundName,
    totalPotPercentage,
  } = props;

  const { potBreakDown } =
    typeof viewPotInfo !== "undefined" ? viewPotInfo : "";
  const [savingsPotRender, setSavingsPotRender] = useState(0);
  const [viewbreakdownRender, setViewbreakdownRender] = useState(0);
  const [activePopover, setActiveOpoover] = useState(null);
  const [potBreakDownArray, setPotBreakDownArray] = useState([]);
  const [lastNegativeIndex, setLastNegativeIndex] = useState(0);
  // prettier-ignore
  const textRef = Array.from(
    {
      length:
        savingsBreakdown === true
          ? savingsPotBreakdown?.potInfo?.length
          : drawDownBreakdown === true
            ? drawDownPotBreakdown?.potInfo?.length
            : potBreakDown?.length,
    },
    () => useRef()
  );

  useEffect(() => {
    setPotBreakDownArray(
      potBreakDown
        ?.filter((x) => x.contributedValue < 0)
        .concat(potBreakDown.filter((x) => x.contributedValue >= 0)),
    );
  }, [potBreakDown]);

  useEffect(() => {
    setLastNegativeIndex(
      potBreakDownArray?.findLastIndex((x) => x.contributedValue < 0),
    );
  }, [potBreakDownArray]);

  useEffect(() => {
    setSavingsPotRender(1);
    setViewbreakdownRender(viewbreakdownRender + 1);
  }, [savingsPotRender, savingsBreakdown]);

  const handlePlusIconClick = (index) => {
    setActiveOpoover((prevIndex) => (prevIndex === index ? null : index));
  };

  const savingsPotTooltip = (savingsBreakdown, item, type) => {
    return (
      <Popover className="tooltip-popover-breakdown">
        <Popover.Body className="text-center">
          {savingsBreakdown ? (
            <>
              <p className="pot-breakdown-text mb-0">{item?.potId}</p>
              <p className="pot-breakdown-text mb-0">{item?.potName}</p>
              {type === "savings" ? (
                <div className="mt-1 mb-0">
                  <span className="pot-breakdown-value">
                    {" "}
                    £{`${addCommas(Math.trunc(item?.totalPotValue))}`}
                  </span>
                  <span className="pot-breakdown-subsetsmall">{`.${(
                    item?.totalPotValue % 1
                  )
                    .toFixed(2)
                    .substring(2)}`}</span>
                </div>
              ) : (
                <div className="mt-1 mb-0">
                  <span className="pot-breakdown-value">
                    {" "}
                    £
                    {addCommas(
                      Math.trunc(item?.drawdownValue) // eslint-disable-line
                    )}
                    .
                  </span>
                  <span className="pot-breakdown-subsetsmall">
                    {(item?.drawdownValue % 1).toFixed(2).substring(2)}
                  </span>
                </div>
              )}
              {type === "savings" && item?.totalPotValue > 0 ? (
                <Buttons
                  name="View breakdown"
                  className="tertiary pot-view-breakdown-btn"
                  handleClick={props.handleSavingsViewBreakdown}
                  id={`${item?.potId}-` + type}
                ></Buttons>
              ) : type === "drawDown" && item?.drawdownValue > 0 ? (
                <Buttons
                  name="View breakdown"
                  className="tertiary pot-view-breakdown-btn"
                  handleClick={props.handleSavingsViewBreakdown}
                  id={`${item?.potId}-` + type}
                ></Buttons>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              <p className="pot-breakdown-text mb-0">
                {item?.contributionName}
              </p>
              <div className="mt-1 mb-0">
                <span className="pot-breakdown-value ">
                  {" "}
                  £
                  {Number.isInteger(item?.contributedValue)
                    ? addCommas(item?.contributedValue)
                    : addCommas(item?.contributedValue)?.split(".")[0]}
                </span>
                <span className="pot-breakdown-subsetsmall ">
                  {Number.isInteger(item?.contributedValue)
                    ? ".00"
                    : `.${addCommas(item?.contributedValue)?.split(".")[1]}`}
                </span>
              </div>
            </>
          )}
        </Popover.Body>
      </Popover>
    );
  };
  const tooltip = (
    <Popover id="popover-contained" className="ec-popover-inner">
      <Popover.Body style={{ paddingTop: "5px" }}>
        <div className="Why-cant-I-edit-cer mb-2">
          <strong>Employer contribution</strong>
        </div>
        <div className="Changing-your-title mb-2">
          We&apos;ve included your salary sacrifice here (instead of under the
          employee contribution).
        </div>
      </Popover.Body>
    </Popover>
  );
  return (
    <Col lg={12} md={12} sm={12} xs={12} className="d-flex">
      {savingsBreakdown && drawDownBreakdown && mobileView ? (
        <>
          {parseFloat(savingsPotBreakdown.totalValue) === 0 ? (
            ""
          ) : (
            <Card
              key={0}
              style={{
                width: `${totalPotPercentage[0] - 0.4}%`,
                height: "24px ",
                backgroundColor: "var(--fuchsia-100)",
                border: "none",
                borderRadius: `8px 0px 0px 8px`,
                marginRight: `13px`,
              }}
            >
              {selectedIndex === 0 && (
                <Col
                  style={{
                    position: "absolute",
                    bottom: "-28px",
                    alignSelf: "center",
                    transition: "transform 1s",
                  }}
                >
                  <div>
                    <div>
                      <Icons
                        iconname="indicator"
                        variant="icon-thirtytwo-fifteen-px"
                      />
                    </div>
                  </div>
                </Col>
              )}
            </Card>
          )}
          {parseFloat(savingsPotBreakdown?.totalValue) > 0 &&
          parseFloat(drawDownPotBreakdown?.totalValue) > 0 ? (
            <div className="connecting-plus-icon">
              <Icons iconname="plus" variant="icon-sixteen-px" />
            </div>
          ) : (
            ""
          )}
          <Card
            key={1}
            style={{
              width: `${
                parseFloat(savingsPotBreakdown?.totalValue) === 0
                  ? totalPotPercentage[0]
                  : totalPotPercentage[1] - 0.4
              }%`,
              height: "24px ",
              backgroundColor: "var(--blue-100)",
              border: "none",
              borderRadius: `${
                parseFloat(savingsPotBreakdown?.totalValue) === 0
                  ? "8px 8px 8px 8px"
                  : "0px 8px 8px 0px"
              }`,
              marginLeft: `13px`,
            }}
          >
            {selectedIndex === 1 && (
              <Col
                style={{
                  position: "absolute",
                  bottom: "-28px",
                  alignSelf: "center",
                  transition: "transform 1s",
                }}
              >
                <div>
                  <div>
                    <Icons
                      iconname="indicator"
                      variant="icon-thirtytwo-fifteen-px"
                    />
                  </div>
                </div>
              </Col>
            )}
          </Card>
        </>
      ) : savingsBreakdown ? (
        <>
          {mobileView ? (
            <>
              {savingsPotBreakdown?.potInfo.map((item, index) => (
                <Card
                  key={index}
                  style={{
                    width: `${
                      savingsPercentages[index] === 0
                        ? 10
                        : savingsPercentages[index]
                    }%`,
                    height: "24px ",
                    backgroundColor: "var(--fuchsia-100)",
                    border: "none",
                    borderRadius: `${
                      savingsPotBreakdown?.potInfo.length === 1
                        ? "8px"
                        : index === 0
                          ? "8px 0px 0px 8px"
                          : index === savingsPotBreakdown?.potInfo.length - 1
                            ? "0 8px 8px 0"
                            : "0px"
                    }`,
                  }}
                  className="me-1"
                >
                  {index === selectedIndex && (
                    <Col
                      style={{
                        position: "absolute",
                        bottom: "-28px",
                        alignSelf: "center",
                        transition: "transform 1s",
                      }}
                    >
                      <div>
                        <div>
                          <Icons
                            iconname="indicator"
                            variant="icon-thirtytwo-fifteen-px"
                          />
                        </div>
                      </div>
                    </Col>
                  )}
                </Card>
              ))}
            </>
          ) : (
            <>
              {savingsPotBreakdown?.potInfo?.map((item, index) => (
                <Card
                  key={index}
                  style={{
                    width: `${savingsPercentages[index] - 0.4}%`,
                    height: "156px",
                    backgroundColor: "var(--fuchsia-100)",
                    border: "none",
                    borderRadius: `${
                      savingsPotBreakdown?.potInfo.length === 1
                        ? "8px"
                        : index === 0
                          ? "8px 0px 0px 8px"
                          : index === savingsPotBreakdown?.potInfo.length - 1
                            ? "0 8px 8px 0"
                            : "0px"
                    }`,
                  }}
                  className="me-1"
                >
                  <div
                    className={
                      item.status === "Active"
                        ? "text-center pot-breakdown-ellipsis-text"
                        : "text-center na-pot-breakdown-ellipsis-text"
                    }
                    ref={textRef[index]}
                  >
                    {item.status === "Active" ? (
                      <div className="d-flex justify-content-center mb-3">
                        <p className="active-status-text">
                          {item?.status?.toUpperCase()}
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    {item?.potId} <br />
                    {item?.potName}
                  </div>
                  {textRef[index]?.current?.scrollWidth >
                  textRef[index]?.current?.clientWidth ? (
                    <OverlayTrigger
                      trigger="click" //- it is required to inspect
                      placement="bottom"
                      key={index}
                      show={activePopover === index}
                      overlay={savingsPotTooltip(
                        savingsBreakdown,
                        item,
                        "savings", // eslint-disable-line
                      )}
                      flip={false}
                    >
                      <span
                        className="pot-breakdown-plus-icon"
                        onClick={() => handlePlusIconClick(index)}
                      >
                        <Icons
                          iconname="plus-copy"
                          variant="icon-sixteen-px mb-5"
                        />
                      </span>
                    </OverlayTrigger>
                  ) : (
                    <>
                      <div className="text-center mt-2 mb-2">
                        <span className="pot-breakdown-value">
                          {`£${addCommas(Math.trunc(item?.totalPotValue))}`}.
                        </span>
                        <span className="pot-breakdown-subsetsmall">
                          {(item?.totalPotValue % 1).toFixed(2).substring(2)}
                        </span>
                      </div>
                      {parseFloat(item?.totalPotValue) === 0 ? (
                        ""
                      ) : (
                        <Buttons
                          name="View breakdown"
                          className="tertiary pot-view-breakdown-btn "
                          handleClick={props.handleSavingsViewBreakdown}
                          id={`${item?.potId}-savings`}
                        ></Buttons>
                      )}
                    </>
                  )}
                </Card>
              ))}
            </>
          )}
        </>
      ) : drawDownBreakdown ? (
        <>
          {mobileView ? (
            <>
              {drawDownPotBreakdown?.potInfo.map((item, index) => (
                <Card
                  key={index}
                  style={{
                    width: `${
                      drawDownPercentages[index] === 0
                        ? 10
                        : drawDownPercentages[index]
                    }%`,
                    height: "24px ",
                    backgroundColor: "var(--blue-100)",
                    border: "none",
                    borderRadius: `${
                      drawDownPotBreakdown?.potInfo.length === 1
                        ? "8px"
                        : index === 0
                          ? "8px 0px 0px 8px"
                          : index === drawDownPotBreakdown?.potInfo.length - 1
                            ? "0 8px 8px 0"
                            : "0px"
                    }`,
                  }}
                  className="me-1"
                >
                  {index === selectedIndex && (
                    <Col
                      style={{
                        position: "absolute",
                        bottom: "-28px",
                        alignSelf: "center",
                        transition: "transform 1s",
                      }}
                    >
                      <div>
                        <div>
                          <Icons
                            iconname="indicator"
                            variant="icon-thirtytwo-fifteen-px"
                          />
                        </div>
                      </div>
                    </Col>
                  )}
                </Card>
              ))}
            </>
          ) : (
            drawDownPotBreakdown?.potInfo?.map((item, index) => (
              <Card
                key={index}
                style={{
                  width: `${drawDownPercentages[index] - 0.4}%`,
                  height: "156px",
                  backgroundColor: "var(--blue-100)",
                  border: "none",
                  borderRadius: `${
                    drawDownPotBreakdown?.potInfo.length === 1
                      ? "8px"
                      : index === 0
                        ? "8px 0px 0px 8px"
                        : index === drawDownPotBreakdown?.potInfo.length - 1
                          ? "0 8px 8px 0"
                          : "0px"
                  }`,
                }}
                className="me-1"
              >
                <div
                  className={
                    drawDownPotBreakdown?.potInfo.length === 1
                      ? "text-center pot-breakdown-ellipsis-text"
                      : "text-center drawdown-text pot-breakdown-ellipsis-text"
                  }
                  ref={textRef[index]}
                >
                  <>
                    <div>
                      {drawDownPotBreakdown?.potInfo.length === 1 ? (
                        <div className="d-flex justify-content-center mb-3">
                          <p className="drawdown-status-text">DRAWDOWN</p>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {item?.potId} <br />
                    {item?.potName}
                    <div className="text-center mt-2 mb-2">
                      <span className="pot-breakdown-value">
                        £
                        {addCommas(
                          Math.trunc(item?.drawdownValue) // eslint-disable-line
                        )}
                        .
                      </span>
                      <span className="pot-breakdown-subsetsmall">
                        {(item?.drawdownValue % 1).toFixed(2).substring(2)}
                      </span>
                    </div>
                  </>
                </div>
                {textRef[index]?.current?.scrollWidth >
                textRef[index]?.current?.clientWidth ? (
                  <OverlayTrigger
                    trigger="click" //- it is required to inspect
                    placement="bottom"
                    show={activePopover === index}
                    overlay={savingsPotTooltip(
                      drawDownBreakdown,
                      item,
                      "drawDown", // eslint-disable-line
                    )}
                    flip={false}
                  >
                    <span
                      className="pot-breakdown-plus-icon-drawdown"
                      onClick={() => handlePlusIconClick(index)}
                    >
                      <Icons
                        iconname="plus-copy"
                        variant="icon-sixteen-px mb-5"
                      />
                    </span>
                  </OverlayTrigger>
                ) : parseFloat(item?.drawdownValue) === 0 ? (
                  ""
                ) : (
                  <>
                    <Buttons
                      name="View breakdown"
                      className="tertiary pot-view-breakdown-btn "
                      handleClick={props.handleSavingsViewBreakdown}
                      id={`${item?.potId}-drawDown`}
                    ></Buttons>
                  </>
                )}
              </Card>
            ))
          )}
        </>
      ) : (
        <>
          {mobileView ? (
            potBreakDownArray?.every(
              (contribution) => parseFloat(contribution.contributedValue) === 0, // eslint-disable-line
            ) === true ? (
              <Row className="no-details-found-mob">
                <Col>No details found</Col>
              </Row>
            ) : (
              <>
                {potBreakDownArray?.map((item, index) => (
                  <Card
                    key={index}
                    style={{
                      width: `${percentages[index]}%`,
                      height: "24px",
                      border:
                        fundName === FUNDNAME.SAVINGS
                          ? "solid 1.5px var(--fuchsia-100)"
                          : "solid 1.5px  var(--blue-100)",
                      backgroundColor: `${
                        index === selectedIndex && fundName === FUNDNAME.SAVINGS
                          ? "var(--fuchsia-100)"
                          : index === selectedIndex &&
                              fundName === FUNDNAME.DRAWDOWN
                            ? "var(--blue-100)"
                            : ""
                      }`,
                      borderRadius: `${
                        index === 0
                          ? "8px 0 0 8px"
                          : index === potBreakDownArray.length - 1
                            ? "0 8px 8px 0"
                            : "0"
                      }`,
                    }}
                    className="me-1"
                  >
                    {index === selectedIndex && (
                      <Col
                        style={{
                          position: "absolute",
                          transition: "1s",
                          bottom: "-28px",
                          alignSelf: "center",
                        }}
                      >
                        <div>
                          <div>
                            <Icons
                              iconname="indicator"
                              variant="icon-thirtytwo-fifteen-px"
                            />
                          </div>
                        </div>
                      </Col>
                    )}
                  </Card>
                ))}
              </>
            )
          ) : potBreakDownArray?.every(
              (contribution) => parseFloat(contribution.contributedValue) === 0, // eslint-disable-line
            ) === true ? (
            <Row className="no-details-found-css">
              <Col>No details found</Col>
            </Row>
          ) : (
            potBreakDownArray?.map((item, index) => (
              <>
                <Card
                  key={index}
                  style={{
                    width: `${percentages[index] - 0.4}%`,
                    height: "156px",
                    borderLeft: `${
                      index <= lastNegativeIndex && index == 0
                        ? fundName === FUNDNAME.SAVINGS
                          ? "solid 8px var(--fuchsia-100)"
                          : "solid 8px var(--blue-100)"
                        : fundName === FUNDNAME.SAVINGS
                          ? "solid 2px var(--fuchsia-100)"
                          : "solid 2px var(--blue-100)"
                    }`,
                    border:
                      fundName === FUNDNAME.SAVINGS
                        ? "solid 2px var(--fuchsia-100)"
                        : "solid 2px var(--blue-100)",
                    borderRadius: `${
                      index === 0
                        ? "8px 0 0 8px"
                        : index === potBreakDownArray.length - 1
                          ? "0 8px 8px 0"
                          : "0"
                    }`,
                    backgroundColor: `${
                      index <= lastNegativeIndex ? "var(--blue-20)" : ""
                    }`,
                  }}
                  className="me-1"
                >
                  <div
                    className="text-center mt-5"
                    style={{ paddingLeft: "5px", paddingRight: "5px" }}
                  >
                    <div className="contribution-title-wrapper">
                      <p
                        className="view-breakdown-text mb-0"
                        ref={textRef[index]}
                      >
                        {item?.contributionName}
                      </p>
                      {item?.contributionName === "Employer contributions" &&
                        item?.isSalarySacrifice === true && (
                          <OverlayTrigger
                            placement="right"
                            overlay={tooltip}
                            trigger={["hover", "focus"]}
                            rootClose
                          >
                            <span
                              className="tooltip-icon"
                              tabIndex={0}
                              style={{ pointerEvents: "auto" }}
                            >
                              <Icons
                                iconname="tool-tip"
                                variant="icon-sixteen-px"
                              />
                            </span>
                          </OverlayTrigger>
                        )}
                    </div>
                    <div
                      className="mt-2 mb-2 view-breakdown-value-wrapper"
                      ref={textRef[index]}
                    >
                      <span className="view-breakdown-value">
                        {" "}
                        {String(item?.contributedValue)?.includes("-")
                          ? `-£${addCommas(
                              Math.trunc(
                                String(item?.contributedValue)?.split("-")[1], // eslint-disable-line
                              ), // eslint-disable-line
                            )}.`
                          : `£${addCommas(
                              Math.trunc(
                                item?.contributedValue, // eslint-disable-line
                              ), // eslint-disable-line
                            )}.`}
                      </span>
                      <span className="view-breakdown-subsetsmall">
                        {(Math.abs(item?.contributedValue) % 1)
                          .toFixed(2)
                          .substring(2)}
                      </span>
                    </div>
                    {percentages[index] !== 0 ? (
                      textRef[index]?.current?.scrollWidth >
                      textRef[index]?.current?.clientWidth ? (
                        <OverlayTrigger
                          // trigger="click" //- it is required to inspect
                          placement="bottom"
                          overlay={savingsPotTooltip(savingsBreakdown, item)}
                          flip={false}
                        >
                          <span className="breakdown-plus-icon">
                            <Icons
                              iconname="plus-boarder"
                              variant="icon-sixteen-px mt-3 m-0"
                            />
                          </span>
                        </OverlayTrigger>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </Card>
                {index === lastNegativeIndex ? (
                  <div
                    className={
                      fundName === FUNDNAME.DRAWDOWN
                        ? "vertical-line"
                        : "vertical-line-saving"
                    }
                  >
                    <p className="payment-in-plus-icon">
                      {" "}
                      <Icons iconname="plus" variant="icon-sixteen-px" />
                    </p>
                    <p className="payment-out-plus-icon"></p>
                  </div>
                ) : (
                  ""
                )}
              </>
            ))
          )}
        </>
      )}
    </Col>
  );
};

export default SavingsBarChart;
